<template>
  <main>
    <HeaderMain type="" />

    <router-view keep-alive />
  </main>
</template>

<script>
export default {
  components: {
    HeaderMain: () => import(/* webpackChunkName: "header-main" */'../components/Header.vue'),
  },
};
</script>
